module.exports = __webpack_public_path__ + "img/galaxymars.7b065613.png";